import React from 'react'
import Main from '../Checkout/Main'

export const Checkout = () => {
  return (
    <>
    <Main />
    </>
  )
}
